<form #form="ngForm">
    <app-form-group [icon]="icon" [label]="label" labelFor="cep">
        <input
            id="cep"
            name="cep"
            type="text"
            [(ngModel)]="endereco.cep"
            (ngModelChange)="onChange()"
            (blur)="onCepExit()"
            class="form-control"
            mask-number
            [mask]="'00000-000'"
            placeholder="00000-000"
            appShowErrorMessages
            required>
        <a
            *ngIf="!isBuscandoCep"
            class="font-orange"
            title="Consultar site dos correios"
            target="_blank"
            (click)="onClickFindCep()" rel="noopener">Não sabe o CEP?</a>
        <app-loader-default text="Buscando CEP" [show]="isBuscandoCep" size="fa-1x"></app-loader-default>
        <div class="info-cep" *ngIf="agenteEndereco">
          <span class="small-icon icon_info"></span>
          <div>
            <h5 class="font-orange">
              Essa proposta será enviada para o Agente:
            </h5>
            <h5>
              {{ agenteEndereco.code }} - {{ agenteEndereco.name }} -
              {{ agenteEndereco.address.city }},
              {{ agenteEndereco.address.state }}
            </h5>
          </div>
        </div>
        <div class="info-cep" *ngIf="cepErrorStatus === 404">
          <span class="small-icon icon_error"></span>
          <div>
            <h5 class="font-red">
              CEP indisponível! Não será possível atender um cliente dessa
              região
            </h5>
            <h5>
              Cidade: {{ endereco.cidade }} | Estado:
              {{ endereco.estado }}
            </h5>
          </div>
        </div>
    </app-form-group>

    <app-form-group label="Endereço" labelFor="endereco">
      <input
          [disabled]="isBuscandoCep"
          [readonly]="hasLogradouro"
          id="endereco"
          name="endereco"
          type="text"
          [(ngModel)]="endereco.endereco"
          (ngModelChange)="onChange()"
          class="form-control"
          placeholder="Rua, Avenida, Alameda..."
          maxlength="150"
          appShowErrorMessages
          appTextUppercase
          appOnlyLetter
          required>
    </app-form-group>


    <app-form-group>
        <div class="col-xs-4 padding0">
            <label for="numero">Número</label>
            <input
                appOnlyNumber
                appNotCaracter
                [disabled]="isBuscandoCep"
                type="text"
                name="numero"
                if="numero"
                [(ngModel)]="endereco.numero"
                (ngModelChange)="onChange()"
                class="form-control"
                placeholder="Número"
                maxlength="8"
                appShowErrorMessages
                required>
        </div>
        <div class="col-xs-8">
            <label for="complemento">Complemento</label>
            <input
                [disabled]="isBuscandoCep"
                type="text"
                [(ngModel)]="endereco.complemento"
                (ngModelChange)="onChange()"
                name="complemento"
                class="form-control"
                id="complemento"
                placeholder="Apartamento, casa..."
                maxlength="20"
                appNotCaracter
                appTextUppercase>
        </div>
    </app-form-group>

    <app-form-group label="Bairro" labelFor="bairro">
      <input
          [disabled]="isBuscandoCep"
          [readonly]="hasBairro"
          id="bairro"
          name="bairro"
          type="text"
          [(ngModel)]="endereco.bairro"
          (ngModelChange)="onChange()"
          class="form-control"
          placeholder="Bairro"
          maxlength="100"
          appShowErrorMessages
          appTextUppercase
          appOnlyLetter
          required>
    </app-form-group>

    <app-uf-cidade-select [disabled]="isBuscandoCep || (endereco.uf && endereco.uf.length > 0)" #appUfCidade [(uf)]="endereco.uf" (ufChange)="onChange()" [(cidade)]="endereco.cidade" (cidadeChange)="onChange()"></app-uf-cidade-select>
</form>

<app-modal-message #modalMessage title="Atenção"></app-modal-message>
